<template>
  <v-dialog v-model="dialog.open" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <div>
      <div class="top-bar">
        <div @click="close()" class="action">
          <v-icon class="px-1">mdi-arrow-left</v-icon>
        </div>
        <div style="font-size: 20px; margin-left: 10px; letter-spacing: 1px">BACKUP DE FOTOS/VÍDEOS</div>
      </div>

      <div style="padding: 15px 15px">
        <v-row>
          <v-col v-for="photo in photos" :key="photo.id" cols="6">
            <v-card :loading="photo.loading">
              <video v-if="photo?.type?.includes('video/')" width="100%" height="193px" controls style="border-radius: 5px; background-color: #000">
                <source :src="photo.photo_url" type="video/mp4" />
              </video>
              <v-img v-else :src="photo.photo_url" class="white--text align-end" height="200px"> </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn icon @click="resyncPhoto(photo)">
                  <v-icon>mdi-sync</v-icon>
                </v-btn>

                <v-btn icon @click="downloadPhotoToGalery(photo)">
                  <v-icon>mdi-download</v-icon>
                </v-btn>

                <v-btn icon @click="openDeleteModal(photo)">
                  <v-icon color="red">mdi-trash-can</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <ModalDeletePhoto :is-active="dialogDelete.open" @close="closeDeleteModal" @save="saveDeleteModal" />
  </v-dialog>
</template>

<script>
import dexieDB from '@/services/dexieService';
import Median from 'median-js-bridge';
import { appendMetadataToFormData } from '@/services/mediaMetadata';

import ModalDeletePhoto from './ModalBackupPhotos/ModalDeletePhoto';

export default {
  components: { ModalDeletePhoto },
  emits: ['close', 'resync-photo', 'delete-photo'],
  props: {
    dialog: Object
  },
  data() {
    return {
      photos: [],
      dialogDelete: { open: false, photo: null }
    };
  },
  computed: {
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    }
  },
  watch: {
    dialog: {
      handler(newValue) {
        if (!newValue) return;

        this.checkBackupMedias();
      },
      deep: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    checkBackupMedias() {
      dexieDB.checkPendingServiceOrderPhoto(this.service_order.id).then((pendingPhotos) => {
        if (pendingPhotos.length > 0) {
          this.photos = pendingPhotos.map((photo) => ({
            ...photo,
            photo_url: URL.createObjectURL(photo.media),
            loading: false
          }));
        } else {
          this.$emit('delete-photo');
        }
      });
    },
    openDeleteModal(photo) {
      this.dialogDelete = {
        open: true,
        photo
      };
    },
    closeDeleteModal() {
      this.dialogDelete = {
        open: false,
        photo: null
      };
    },
    async saveDeleteModal() {
      await dexieDB.removeServiceOrderPhoto(this.dialogDelete.photo.id);

      this.checkBackupMedias();

      this.dialogDelete = {
        open: false,
        photo: null
      };
    },
    async resyncPhoto(photo) {
      if (photo.loading) return;

      photo.loading = true;

      try {
        const formData = new FormData();
        formData.append('file', photo.media);
        formData.append('tag', photo.tag);
        formData.append('type', photo.type);
        appendMetadataToFormData(formData);

        const response = await this.$http.post(`/service_order/${this.service_order.id}/photo/create?type=os&tag=${photo.tag}`, formData, {
          timeout: 1000 * 120,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.$emit('resync-photo', { ...photo, created_at: response.data.created_at }, response);
      } finally {
        photo.loading = false;
      }
    },
    downloadPhotoToGalery(photo) {
      Median.share.downloadImage({ url: photo.photo_url });
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  width: 100%;
  overflow: hidden;
  padding: 4px 10px;
  background-color: #fff;
  border-bottom: 1px solid #d9d8de;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .action {
    border: 1px solid #c8c8c8;
    padding: 8px;
    margin: 8px;
    float: left;
    border-radius: 6px;
  }
}
</style>
